<template>
  <div>
    <van-form class="post" @submit="onSubmit">
      <van-field v-if="type != 1" readonly clickable size="large" :rules="[{ required: true }]" name="picker"
        v-model="name" label="一尘版块" placeholder="点击选择一尘版块" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="plateList" value-key="name" @confirm="onConfirm"
          @cancel="showPicker = false" />
      </van-popup>
      <van-field v-if="type != 1" v-model="topic" size="large" name="标题" label="标题（最多不超过200个汉字）" placeholder="请输入帖子标题"
        :rules="[{ required: true }]" />

      <div v-if="false" class="facerow">
        <div class="labelt">当前心情</div>
        <div @click="showFace = true" class="faceimg">
          <img :src="require('/src/assets/face/face' + faceValue + '.gif')" alt="" />
          <van-icon name="arrow" />
        </div>
      </div>
      <van-popup v-model="showFace" position="center">
        <div style="width:320px;height:300px;padding: 20px;text-align: center;    overflow: auto;">
          <img @click="addHtml(index + 1)" v-for="(i, index) in 48" :key="i" class="emoimg"
            :src="require('/src/assets/face/emo/em' + Number(Number(index) + 1) + '.gif')" alt="" />
        </div>
      </van-popup>
      <!-- <van-field
        v-model="body"
        autosize
        rows="5"
        size="large"
        type="textarea"
        name="帖子内容"
        label="帖子内容"
        show-word-limit
        maxlength="510"
        placeholder="请输入帖子内容描述"
        :rules="[{ required: true }]"
      /> -->

      <van-field size="large" name="uploader" label="帖子内容">
        <template #input>
          <div>
            <Editor style="height: 270px; width:100%;font-size:14px;overflow-y: hidden;" v-model="html"
              :defaultConfig="editorConfig" mode="default" @onCreated="onCreated" />
            <div class="scorllbottomFix">
              <img @click="addHtml(item)" style="width:22px;height:22px;margin-right:20px;"
                v-for="item in [1, 2, 3, 4, 5, 6, 7]" :key="item" :src="require(`/src/assets/face/emo/em${item}.gif`)"
                alt="" />
              <span @click="showFace = true">更多 <van-icon name="arrow" /></span>
            </div>
          </div>
        </template>
      </van-field>
      <uploader v-model="uploader"></uploader>

      <div style="margin: 16px;">
        <van-button round block type="info" :disabled="isloading" size="small" native-type="submit">回复</van-button>
      </div>
    </van-form>
  </div>
</template>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import { client, options } from '@/utils/oss';
import { getSectionList, createPost, replyPost } from '@/api/base';
import { geturlparam, IsPC } from '@/utils/index';
import { asyncIsVip } from '@/utils/isVip';
import uploader from '../components/uploader.vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
export default {
  components: {
    uploader,
    Editor,
    Toolbar,
  },
  data() {
    return {
      name: null,
      isloading: false,
      html: '<p> </p>',
      topic: '',
      body: '',
      uploader: [],
      isUploading: false,
      showPicker: false,
      plateList: [],
      sectionUrl: '',
      faceValue: 1,
      showFace: false,
      type: null, //1 回复
      url: null,
      isVip: false,
      editor: null,
      editorConfig: { placeholder: '请输入帖子内容描述...' },
      emoindex: 1,
    };
  },
  created() {
    this.verification();
    this.init();
    this.type = this.$route.query.type ? this.$route.query.type : null;
    this.url = this.$route.query.url ? this.$route.query.url : null;
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    addHtml(index) {
      this.emoindex = index;
      let str = this.editor.getHtml();
      let parser = new DOMParser();
      let doc = parser.parseFromString(str, 'text/html'); // 第2个参数为mimeType，可以为 text/html, text/xml 等等这些
      // 解析好的DOM节点
      let nodes = doc.body;
      let img = document.createElement('img');
      img.src = require(`/src/assets/face/emo/em${index}.gif`);
      img.style.width = '22px';
      img.style.height = '22px';
      img.setAttribute('alt', `em${index}.gif`);
      img.style.marginbottom = '20px';
      nodes.lastChild.appendChild(img);
      let content = nodes.innerHTML;
      this.editor.setHtml(content);
      this.showFace = false;
    },
    verification() {
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      if (userinfo == null) {
        console.log('为空');
        this.$router.replace('/yclogin');
        return;
      }
    },
    async onSubmit(values) {
      let that = this;
      console.log(this.html);
      let content = this.html;

      let imgReg = /<img.*?(?:>|\/>)/gi;
      //筛选出所有的img
      let arr = content.match(imgReg);
      let altReg = /alt=[\'\"]?([^\'\"]*)[\'\"]?/i;
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
      if (arr && arr.length > 0) {
        arr.map(it => {
          const src = it.match(altReg);
          if (src[1].indexOf('gif') != -1) {
            let str = src[1].split('em');
            let str1 = str[1].split('.gif');
            console.log(str1);
            content = content.replace(it, `[em${Number(str1[0]) < 10 ? '0' + str1[0] : str1[0]}]`);
          }
        });
      }
      console.log(content);
      this.isVip = await asyncIsVip(2);
      console.log(this.isVip);
      if (!this.isVip) {
        return;
      }
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      this.$dialog
        .confirm({
          title: '提示',
          message: `当前账号：${userinfo.userName}\n您确认回复当前内容？`,
        })
        .then(() => {
          this.isloading = true;
          this.$toast.loading({
            message: '发布中...',
            forbidClick: true,
          });
          let imgs = [];
          that.uploader.map(item => {
            imgs.push('[IMG]' + item.url + '[/IMG]');
          });
          let body = `${content}${imgs.toString()}`;
          let obj = {
            body: body,
            sectionUrl: that.sectionUrl,
            topic: that.topic,
            userName: userinfo.userName,
            passWord: userinfo.passWord,
            uuid: userinfo.uuid,
            expression: `face${that.faceValue}.gif`,
          };
          replyPost({
            body: body,
            expression: `face${that.faceValue}.gif`,
            passWord: userinfo.passWord,
            postUrl: decodeURIComponent(decodeURIComponent(that.url)),
            userName: userinfo.userName,
            uuid: userinfo.uuid,
          })
            .then(res => {
              that.$toast('回复成功');
              that.$router.push({
                path: '/postView',
                query: {
                  href: that.url,
                  ...(IsPC() ? { _t: Date.now() } : {}),
                },
              });
              that.isloading = false;
            })
            .catch(err => {
              that.isloading = false;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    onConfirm(value, e) {
      //   this.ruleFrom.code = this.plateList[e[0]].children[e[1]].code;
      this.name = value.toString();
      let url = this.plateList[e[0]].children[e[1]].url;
      this.sectionUrl = geturlparam(url, 'boardid');
      this.showPicker = false;
    },
    init() {
      let str = window.localStorage.getItem('plateList');
      if (JSON.parse(str) && JSON.parse(str).length > 1) {
        this.plateList = JSON.parse(str);
      } else {
        getSectionList().then(res => {
          this.plateList = res.data.sort((a, b) => a.sortno - b.sortno);
          this.plateList.map(item => {
            item.children.sort((a, b) => a.sortno - b.sortno);
          });
          window.localStorage.setItem('plateList', JSON.stringify(this.plateList));
        });
      }
    },
    checkedFace(i) {
      this.faceValue = i;
      this.showFace = false;
    },
  },
};
</script>
<style>
.post .van-cell {
  display: block;
}

.post .van-cell .van-cell__title {
  width: auto;
}
</style>
<style scoped>
.facerow {
  display: flex;
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px;
  overflow: hidden;
  color: #323233;
  font-size: 16px;
  line-height: 24px;
  background-color: #fff;
  position: relative;
}

.facerow .labelt {
  color: #646566;
}

.facerow .faceimg {
  padding-left: 40px;
}

.facerow::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.emoimg {
  width: 33px;
  height: 32px;
  margin-right: 15px;
  margin-bottom: 20px;
}

.emoimg:nth-child(6n) {
  margin-right: 0;
}
</style>
<style>
.w-e-text-container [data-slate-editor] {
  padding: 0;
}

.w-e-max-length-info,
.w-e-text-placeholder {
  font-style: normal;
}
</style>
